import { DataPosition, PlatformPosition, PositionGroup } from '../../types/position';


export const positionOptionsPlatform: PlatformPosition[] = [
  'LS',
  'S',
  'RS',

  'LW',
  'RW',

  'LCAM',
  'CAM',
  'RCAM',

  'LM',
  'LCM',
  'CM',
  'RCM',
  'RM',

  'LCDM',
  'CDM',
  'RCDM',

  'LWB',
  'LB',
  'LCB',
  'CB',
  'RCB',
  'RB',
  'RWB',

  'GK',
];


export const groupedPositionOptionsPlatfrom: PlatformPosition[][][] = [
  [['S'], ['LS', 'RS']],
  [['LW', 'RW'], ['LCAM', 'CAM', 'RCAM']],
  [['LM', 'RM'], ['LCM', 'CM', 'RCM']],
  [['LCDM', 'RCDM'], ['CDM']],
  [['LWB', 'LB', 'RB', 'RWB'], ['LCB', 'CB', 'RCB',]],
  [['GK']],
];


export const positionOptionsData: DataPosition[] = [
  'S',
  'LW',
  'RW',
  'CAM',
  'CM',
  'CDM',
  'LB',
  'RB',
  'CB',
  'GK',
];


export const platformPositionToSortOrder: Record<PlatformPosition, number> = {
  'LS': 63,
  'S': 62,
  'RS': 61,

  'LW': 62,
  'RW': 51,

  'LCAM': 43,
  'CAM': 42,
  'RCAM': 41,

  'LM': 35,
  'LCM': 34,
  'CM': 33,
  'RCM': 32,
  'RM': 31,

  'LCDM': 23,
  'CDM': 22,
  'RCDM': 21,

  'LWB': 17,
  'LB': 16,
  'LCB': 15,
  'CB': 14,
  'RCB': 13,
  'RB': 12,
  'RWB': 11,

  'GK': 1,
};


// every key here should map to a list of all positions, ordered by how close they are concepetually
export const positionToClosestPositions: Record<PlatformPosition, PlatformPosition[]> = {
  'LS': ['S', 'RS', 'LW', 'LCAM', 'RW', 'CAM', 'RCAM', 'LM', 'RM', 'LCM', 'CM', 'RCM', 'LCDM', 'CDM', 'RCDM', 'LWB', 'LB', 'LCB', 'CB', 'RCB', 'RB', 'RWB'],
  'S': ['LS', 'RS', 'LW', 'RW', 'CAM', 'LCAM', 'RCAM', 'LM', 'RM', 'LCM', 'CM', 'RCM', 'CDM', 'LCDM', 'RCDM', 'LWB', 'LB', 'LCB', 'CB', 'RCB', 'RB', 'RWB'],
  'RS': ['S', 'LS', 'RW', 'RCAM', 'LW', 'CAM', 'LCAM', 'RM', 'LM', 'RCM', 'CM', 'LCM', 'RCDM', 'CDM', 'LCDM', 'RWB', 'RB', 'RCB', 'CB', 'LCB', 'LB', 'LWB'],

  'LW': ['LCAM', 'LM', 'RW', 'LS', 'CAM', 'RCAM', 'RM', 'S', 'RS', 'LWB', 'LB', 'LCM', 'CM', 'RCM', 'RWB', 'RB', 'LCDM', 'CDM', 'RCDM', 'LCB', 'CB', 'RCB'],
  'RW': ['RCAM', 'RM', 'LW', 'RS', 'CAM', 'LCAM', 'LM', 'S', 'LS', 'RWB', 'RB', 'RCM', 'CM', 'LCM', 'LWB', 'LB', 'RCDM', 'CDM', 'LCDM', 'RCB', 'CB', 'LCB'],

  'LCAM': ['LW', 'LS', 'LM', 'CAM', 'RCAM', 'RW', 'RM', 'LCM', 'CM', 'RCM', 'RS', 'S', 'LWB', 'RWB', 'LCDM', 'CDM', 'RCDM', 'LB', 'LCB', 'CB', 'RCB', 'RB'],
  'CAM': ['LCAM', 'RCAM', 'LW', 'RW', 'S', 'LS', 'RS', 'CM', 'LCM', 'RCM', 'LM', 'RM', 'CDM', 'LCDM', 'RCDM', 'LWB', 'LB', 'LCB', 'CB', 'RCB', 'RB', 'RWB'],
  'RCAM': ['RW', 'RS', 'RM', 'CAM', 'LCAM', 'LW', 'LM', 'RCM', 'CM', 'LCM', 'LS', 'S', 'RWB', 'LWB', 'RCDM', 'CDM', 'LCDM', 'RB', 'RCB', 'CB', 'LCB', 'LB'],

  'LM': ['LW', 'LCAM', 'LWB', 'RM', 'RW', 'RCAM', 'RWB', 'CAM', 'LB', 'LCM', 'CM', 'RCM', 'LS', 'RS', 'S', 'RB', 'LCDM', 'CDM', 'RCDM', 'LCB', 'CB', 'RCB'],
  'RM': ['RW', 'RCAM', 'RWB', 'LM', 'LW', 'LCAM', 'LWB', 'CAM', 'RB', 'RCM', 'CM', 'LCM', 'RS', 'LS', 'S', 'LB', 'RCDM', 'CDM', 'LCDM', 'RCB', 'CB', 'LCB'],

  'LCM': ['CM', 'RCM', 'LCDM', 'CDM', 'RCDM', 'LCAM', 'CAM', 'RCAM', 'LM', 'RM', 'LW', 'RW', 'LS', 'RS', 'S', 'LCB', 'CB', 'RCB', 'LWB', 'RWB', 'LB', 'RB'],
  'CM': ['LCM', 'RCM', 'CDM', 'LCDM', 'RCDM', 'CAM', 'LCAM', 'RCAM', 'LM', 'RM', 'LW', 'RW', 'CB', 'LCB', 'RCB', 'S', 'LS', 'RS', 'LWB', 'RWB', 'LB', 'RB'],
  'RCM': ['CM', 'LCM', 'RCDM', 'CDM', 'LCDM', 'RCAM', 'CAM', 'LCAM', 'RM', 'LM', 'RW', 'LW', 'RS', 'LS', 'S', 'RCB', 'CB', 'LCB', 'RWB', 'LWB', 'RB', 'LB'],

  'LCDM': ['CDM', 'RCDM', 'LCM', 'CM', 'RCM', 'LCB', 'CB', 'RCB', 'LCAM', 'CAM', 'RCAM', 'LB', 'RB', 'LWB', 'RWB', 'LM', 'RM', 'LW', 'RW', 'LS', 'RS', 'S'],
  'CDM': ['LCDM', 'RCDM', 'CM', 'LCM', 'RCM', 'CB', 'LCB', 'RCB', 'CAM', 'LCAM', 'RCAM', 'LB', 'RB', 'LWB', 'RWB', 'LM', 'RM', 'LW', 'RW', 'LS', 'RS', 'S'],
  'RCDM': ['CDM', 'LCDM', 'RCM', 'CM', 'LCM', 'RCB', 'CB', 'LCB', 'RCAM', 'CAM', 'LCAM', 'RB', 'LB', 'RWB', 'LWB', 'RM', 'LM', 'RW', 'LW', 'RS', 'LS', 'S'],

  'LWB': ['LB', 'LM', 'LW', 'LCAM', 'RWB', 'RB', 'RM', 'RW', 'RCAM', 'LCB', 'RCB', 'CB', 'LCDM', 'CDM', 'RCDM', 'LCM', 'CM', 'RCM', 'CAM', 'LS', 'RS', 'S'],
  'LB': ['LWB', 'LM', 'LW', 'LCAM', 'RB', 'RWB', 'RM', 'RW', 'RCAM', 'LCB', 'RCB', 'CB', 'LCDM', 'CDM', 'RCDM', 'LCM', 'CM', 'RCM', 'CAM', 'LS', 'RS', 'S'],

  'RWB': ['RB', 'RM', 'RW', 'RCAM', 'LWB', 'LB', 'LM', 'LW', 'LCAM', 'RCB', 'LCB', 'CB', 'RCDM', 'CDM', 'LCDM', 'RCM', 'CM', 'LCM', 'CAM', 'RS', 'LS', 'S'],
  'RB': ['RWB', 'RM', 'RW', 'RCAM', 'LB', 'LWB', 'LM', 'LW', 'LCAM', 'RCB', 'LCB', 'CB', 'RCDM', 'CDM', 'LCDM', 'RCM', 'CM', 'LCM', 'CAM', 'RS', 'LS', 'S'],

  'LCB': ['CB', 'RCB', 'LCDM', 'CDM', 'RCDM', 'LB', 'RB', 'LWB', 'RWB', 'LCM', 'CM', 'RCM', 'LM', 'RM', 'LCAM', 'RCAM', 'CAM', 'LW', 'RW', 'LS', 'RS', 'S'],
  'CB': ['LCB', 'RCB', 'CDM', 'LCDM', 'RCDM', 'LB', 'RB', 'LWB', 'RWB', 'CM', 'LCM', 'RCM', 'LM', 'RM', 'CAM', 'LCAM', 'RCAM', 'LW', 'RW', 'LS', 'RS', 'S' ],
  'RCB': ['CB', 'LCB', 'RCDM', 'CDM', 'LCDM', 'RB', 'LB', 'RWB', 'LWB', 'RCM', 'CM', 'LCM', 'RM', 'LM', 'RCAM', 'LCAM', 'CAM', 'RW', 'LW', 'RS', 'LS', 'S'],

  'GK': ['CB', 'LCB', 'RCB', 'LB', 'RB', 'LWB', 'RWB', 'CDM', 'LCDM', 'RCDM'],
};


export const positionGroupToPositions: Record<PositionGroup, DataPosition[]> = {
  'S': ['S'],
  'W': ['LW', 'RW', 'CAM'],
  'CM': ['CM', 'CDM'],
  'FB': ['LB', 'RB'],
  'CB': ['CB'],
  'GK': ['GK'],
};
